import { Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Unauthorized from "./display/Unauthorized";
import Loading from "./overlay/Loading";

const ProtectedRoutes = ({ allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <Loading />;
  if (!user) return <Unauthorized />;

  if (!allowedRoles.includes(user.role)) {
    return <Unauthorized />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
